import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFacebookgamingComponent } from './simple-icons-facebookgaming.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFacebookgamingComponent ],
    exports:      [ SimpleIconsFacebookgamingComponent ],
    bootstrap:    []
})
export class SimpleIconsFacebookgamingModule {}
